import { PILLARS, STATS } from "@/data/site";
import Reveal from "@/components/Reveal";
import { Eyebrow } from "@/components/PageHeader";

const Pillars = () => (
  <section data-testid="pillars-section" className="bg-ink">
    <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32">
      <Reveal>
        <Eyebrow>Chi siamo</Eyebrow>
        <h2 className="max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white md:text-7xl">
          Non improvvisiamo. <span className="text-white/30">Progettiamo.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 md:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.n} delay={i * 120} className="bg-ink p-8 md:p-10">
            <span className="font-display text-sm font-bold text-brand">{p.n}</span>
            <h3 className="mt-6 font-display text-2xl font-bold uppercase text-white">{p.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-white/55">{p.text}</p>
          </Reveal>
        ))}
      </div>
      <div className="mt-16 grid grid-cols-2 gap-10 md:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 100} data-testid={`stat-${i}`}>
            <div className="font-display text-5xl font-extrabold text-white md:text-7xl">{s.value}</div>
            <div className="mt-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
              {s.label}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Pillars;
